import React from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/id' // import locale
dayjs.locale('id') // use locale
import ReactDatePicker, { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

import id from 'date-fns/locale/id'

import { DatePickerComponsition, DatePickerProps } from './DatePicker.types'
import { Wrapper } from './styled'
import Input from '../Input'
import Icon from '../Icon'
import Flex from '../Flex'
import RangeDatePicker from './RangeDatePicker'
import TimePicker from './TimePicker'
import SelectInput from '../Select/SelectInput'
import range from 'lodash/range'
import Text from '../Text'

interface PropsCustomHeader extends ReactDatePickerCustomHeaderProps {
  showMonthYearDropdown?: boolean
}

export const SingleDatePickerCustomHeader = ({
  date,
  monthDate,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  showMonthYearDropdown = false,
}: PropsCustomHeader) => {
  const nowYear = new Date().getFullYear()
  const years = range(nowYear + 2, nowYear - 100)
  const months = [
    { value: 'january', label: 'Januari' },
    { value: 'februari', label: 'Februari' },
    { value: 'maret', label: 'Maret' },
    { value: 'april', label: 'April' },
    { value: 'mei', label: 'Mei' },
    { value: 'junei', label: 'Juni' },
    { value: 'juli', label: 'Juli' },
    { value: 'agustus', label: 'Agustus' },
    { value: 'september', label: 'September' },
    { value: 'oktober', label: 'Oktober' },
    { value: 'november', label: 'November' },
    { value: 'desember', label: 'Desember' },
  ]

  const optionYears = years.map((el) => ({ value: el.toString(), label: el.toString() }))

  const monthYearComponent = (
    <>
      <SelectInput
        options={months}
        placeholder='Bulan'
        size='small'
        onChange={(event) => changeMonth(months.indexOf(event))}
        value={months.filter((el) => el.label === dayjs(date).format('MMMM'))[0]}
      />
      <SelectInput
        options={optionYears}
        placeholder='Tahun'
        size='small'
        onChange={(event) => changeYear(+event.value)}
        value={{ value: dayjs(date).format('YYYY'), label: dayjs(date).format('YYYY') }}
      />
    </>
  )

  const defaultComponent = (
    <>
      <Text color='black100' variant='body'>
        {dayjs(monthDate).format('MMMM')}
      </Text>
      <Text color='black100' variant='body' weight='bold'>
        {dayjs(monthDate).format('YYYY')}
      </Text>
    </>
  )

  return (
    <Flex
      alignItems='center'
      width='100%'
      justifyContent='space-between'
      marginBottom={24}
      cursor='pointer'
    >
      <Icon
        name='Left-outline'
        size={20}
        color='black50'
        onClick={decreaseMonth}
        aria-label='Prev Month'
      />
      <Flex color='black100' columnGap='16px' alignItems='center'>
        {showMonthYearDropdown ? monthYearComponent : defaultComponent}
      </Flex>
      <Icon
        name='Right-outline'
        size={20}
        color='black50'
        onClick={increaseMonth}
        aria-label='Next Month'
      />
    </Flex>
  )
}

const DatePicker: React.FC<DatePickerProps> & DatePickerComponsition = ({ ...props }) => {
  return (
    <Wrapper>
      <ReactDatePicker
        placeholderText='Pilih Tanggal'
        locale={id}
        customInput={
          <Input data-testid='date-picker-test-id' prefix={<Icon name='Calendar-outline' />} />
        }
        renderCustomHeader={(ev) =>
          SingleDatePickerCustomHeader({
            ...ev,
            showMonthYearDropdown: props.showMonthYearDropdown,
          })
        }
        {...props}
      />
    </Wrapper>
  )
}

DatePicker.Range = RangeDatePicker
DatePicker.Time = TimePicker

export default DatePicker
